import TableStyled from './TableStyled';

export default TableStyled;
